import TopChatHeader from '@/components/TopChatHeader/top-chat-header.vue'
import Overlay from '@/components/TransparentOverlay/transparentOverlay.vue'
import TopchatPopup from '@/components/TransparentOverlay/popup.vue'
import ChatSpin from '@/components/chatSpin/chatSpin.vue'
import Empty from '@/components/Empty/Empty.vue'
import TopHeader from '@/components/Mobile/TopHeader/index.vue'  // 移动端头部
// import Login from '@/components/Mobile/Login.vue'

const componentList = [
    // pc端
    {name:"TopChatHeader",component:TopChatHeader},
    {name:"Overlay",component:Overlay},
    {name:"TopchatPopup",component:TopchatPopup},
    {name:"ChatSpin",component:ChatSpin},
    {name:'Empty',component:Empty},
    // 移动端
    {name:'TopHeader',component:TopHeader},   // 公共头部
    // {name:'Login',component:Login}            // 登录页
]
export default(Vue)=>{
    componentList.forEach(v=>{
        Vue.component(v.name,v.component)
    })
}